import React from 'react';
import { TranslationUtils } from '../../utils';
import './ReceiptMor.scss';
import { ImageVacasaHorizontal } from '../../assets/images';

interface ReceiptCAFooterNoteProps {
    consumer_protection_bc: any;
}

export const ReceiptCAFooterNote: React.FC<ReceiptCAFooterNoteProps> = (props) => {
    const { consumer_protection_bc } = props;
    const { business_address, business_license, business_licensee_name } = consumer_protection_bc;
    return (
        <div id="items-summary" className="total-receipt-detail">
            <div className="mb-5" />
            <hr />
            <div tabIndex={0} className="col-xs-6">
                <span className="billing-address-title">{TranslationUtils.get('payment_processed_by')}</span>
                <div className="billing-address-detail">
                    <span>{business_licensee_name && business_licensee_name}</span>
                    <div className="mb-1" />
                    <span>{business_address.address_1}</span>
                    <div className="mb-1" />
                    <span>{business_address.address_2}</span>
                    <div className="mb-1" />
                    <span>
                        {business_address.city} {business_address.state} {business_address.zip}
                    </span>
                    {', '}
                    <span>{business_address.country}</span>
                    <div className="mb-1" />
                    <span>{business_license}</span>
                    <div className="mb-1" />
                    <span>{business_address.phone && business_address.phone}</span>
                </div>
            </div>
            <div className="col-xs-6 text-right">
                <ImageVacasaHorizontal className={'receipt-image'} />
            </div>
        </div>
    );
};
